import { isArray } from '@/common/js/utils'

export default {
  computed: {
    fileType () {
      if (!isArray(this.format)) return []
      let name = 'image'
      if (this.name.includes('image')) name = 'image'
      else if (this.name.includes('video')) name = 'video'
      return this.format.map(ret => {
        let mimetype
        const type = ret.split('_')
        const mime = type.pop().toLowerCase()
        // 枚举头信息的类型
        switch (mime) {
          case 'jpg':
            mimetype = 'jpeg'
            break
          case 'avi':
            mimetype = 'x-msvideo'
            break
          case 'mov':
            mimetype = 'quicktime'
            break
          default:
            mimetype = mime
        }
        return `${name}/${mimetype}`
      })
    }
  },
  methods: {
    preUpload (file) {
      const { size, name, type } = file
      if (!this.fileType.includes(type)) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 格式错误！`
        })
        return false
      }
      if (size > this.size * 1024) {
        this.$Message.error({
          closable: true,
          duration: 5,
          content: `上传的文件名 ${name} 超过限制大小`
        })
        return false
      }
      this.uploadFile(file)
      return false
    }
  },
  filters: {
    formatType (types) {
      return types.map(ret => {
        return ret.split('_').pop()
      }).join(' | ')
    },
    smartSize (val) {
      if (typeof val !== 'number') return ''
      if (val >= 1024000) {
        const size = (val / 1024000).toFixed(2)
        return `${size}G`
      } else if (val >= 1024) {
        const size = (val / 1024).toFixed(2)
        return `${size}M`
      } else {
        return `${val}K`
      }
    }
  }
}
